import React from "react";
import { Domains } from "../domains";
import { useDispatch, useSelector } from "react-redux";
import { ConfigurationPanel } from "../..";
import { Select, translateMessage } from "@delibrandev/utils";
import {
  updateAbandonedCartTime,
  getCorporation,
} from "../../../../../../api/configuration";
import {
  setAlert,
  setCorporationData,
} from "../../../../../../reducers/userConfigSlice";

export const AdvancedConfiguration = () => {
  const dispatch = useDispatch();
  const abandonedCartTime = useSelector(
    (state) =>
      state.aplicationConfig.corporationData.info.corporation.abandonedCartTime,
  );
  const updateAbandonedCartTimeQuery = async () => {
    try {
      const payload = {
        abandonedShoppingCartTime: document.getElementById(
          "updateAbandonedCartTime",
        ).value,
      };
      const response = await updateAbandonedCartTime(payload);
      if (response && !response.error) {
        query();
        dispatch(
          setAlert(translateMessage(response?.message || "Bad request")),
        );
      }
    } catch (error) {
      console.error("Error en la petición:", error);
    }
  };

  const query = async () => {
    const response = await getCorporation();
    if (response && !response.error) {
      dispatch(setCorporationData(response.data));
    }
  };

  //setCorporationData

  return (
    <>
      <ConfigurationPanel
        title="Configuración avanzada"
        content={
          <div className="">
            <Select
              value={abandonedCartTime}
              id="updateAbandonedCartTime"
              values={[1, 2, 3, 4, 5].map((time) => ({
                id: time,
                name: time + " hora",
              }))}
              callback={() => null}
              label="Carrito abandonado"
              description="Tiempo que determina si un carrito está abandonado"
              classname=""
            />
          </div>
        }
        action={updateAbandonedCartTimeQuery}
      />
      <details className="platformAdvancedAccess">
        <summary>Gestionar accesos de plataformas</summary>
        <Domains management />
      </details>
    </>
  );
};
